// extracted by mini-css-extract-plugin
module.exports = {"temp":"ItemGrid-module__temp___1POwn","columns":"ItemGrid-module__columns___1G8YZ","column":"ItemGrid-module__column___1aXli","content":"ItemGrid-module__content___C5H7T"};